module.exports = {
    LAYOUT_PARTS: 'LAYOUT_PARTS',
    PAGE_DATA: 'PAGE_DATA',
    GAME_CATEGORY_DATA: 'GAME_CATEGORY_DATA',
    GAME_PLATFORM_DATA: 'GAME_PLATFORM_DATA',
    WINNER_LIST: 'WINNER_LIST',
    VIP_LEVELS: 'VIP_LEVELS',
    TRANSLATION_MESSAGES: 'TRANSLATION_MESSAGES',
    PROMOTION_DATA: 'PROMOTION_DATA',
    NEWS_DATA: 'NEWS_DATA',
    HELP_DATA: 'HELP_DATA',
    SLIDER_SLIDES: 'SLIDER_SLIDES',
    APP_DATA: {
        MAINTENANCE_MODE: 'IS_IN_MAINTENANCE_MODE',
    },
};